import { useParams } from "react-router-dom";
import projects from "../data/projects";
import "./ProjectDetails.css";

const ProjectDetails = () => {

  const { id } = useParams();

  const project = projects.find((item) => item.id === id);

  if (!project) {
    return <h2>Project Not Found</h2>;
  }

  return (
    <section className="project-details">

      <img src={project.image} alt={project.title} />

      <h1>{project.title}</h1>

      <p>{project.description}</p>

      <h3>Technologies Used</h3>

      <ul>
        {project.technologies.map((tech, index) => (
          <li key={index}>{tech}</li>
        ))}
      </ul>

      <div className="links">

        <a href={project.live} target="_blank" rel="noreferrer">
          Live Demo
        </a>

        <a href={project.github} target="_blank" rel="noreferrer">
          GitHub
        </a>

      </div>

    </section>
  );
};

export default ProjectDetails;